module.exports = __webpack_public_path__ + "static/media/unmhospitals.5e8900ef.png";